<template>
    <client-page>
        <sub-visual sh="Distributor in Korea" tabActive="Dupont Kalrez®" bg="/images/sub/visual/sv3.png"> </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container class="mb-lg-42">
                <h2 class="page-tit mb-18 mb-lg-24">
                    <v-img max-width="470" src="/images/logos/kalrez.png" alt="Dupont Kalrez" class="mx-auto" />
                    <!-- Dupont Kalrez® -->
                </h2>
                <h3 class="tit text-center primary--text">Dupont Kalrez® Authorized Distributor</h3>
            </v-container>

            <sub-bg-image src="/images/sub/distributor/kalrez/kalrez-top-img.png" className="h-lg-280px">
                <h3 class="tit font-weight-semibold mb-8 mb-md-50 mb-lg-100">
                    Kalrez® specialty sealing <br class="d-none d-md-block" />
                    engineered for your <br class="d-none d-md-block" />
                    mission-critical applications.
                </h3>
                <p class="page-text color-grey-51 mb-2 mb-lg-10">Kalrez® parts serve a variety of industries, from aerospace and chemical processing to chip manufacturing, oil and gas extraction, and more. More effective, suitable for stability and resistance to harsh conditions in various fields We manufacture products to be sealed.</p>
            </sub-bg-image>
        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="Features">
                    <v-row>
                        <icon-line-box icon="/images/sub/distributor/kalrez/kalrez-icon1.png" iconWidth="50" num="01"> Kalrez® components with a variety of compounds can withstand different chemicals and temperatures. It has durable properties and is excellent in chemical resistance. </icon-line-box>

                        <icon-line-box icon="/images/sub/distributor/kalrez/kalrez-icon2.png" iconWidth="38" num="02">It has strong heat resistance and can replace metals, ceramics, and other polymers. This product is optimized for cost reduction and application in a variety of uses.</icon-line-box>

                        <icon-line-box icon="/images/sub/distributor/kalrez/kalrez-icon3.png" iconWidth="50" num="03"> Kalrez® products are certified products that reduce the possibility of seal failure. Meets stringent requirements for rapid gas decompression </icon-line-box>

                        <icon-line-box icon="/images/sub/distributor/kalrez/kalrez-icon4.png" iconWidth="50" num="04"> Since purity is critical to wafer yield, the specially designed Kalrez® FFKM seal Reduce wafer contamination from particles, outgassing and extractables </icon-line-box>
                    </v-row>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="Kalrez®">
                    <p class="page-text color-grey-51 mb-30 mb-lg-52">Kalrez® parts are manufactured by Dupont Elastomers consistently from raw material polymer to rubber molding. It is a registered trademark of Perfluoro Elastomer parts and is a product made of rubberized Teflon. It is a highly functional rubber material that is highly resistant even in harsh environments. It is used in all industrial fields that require precision and high performance.</p>
                    <v-row no-gutters>
                        <v-col cols="12" md="4">
                            <table class="client-table client-table-lg w-100 border-md-end">
                                <colgroup>
                                    <col style="width: 25%" />
                                    <col style="width: 75%" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Plasma Process</div>
                                        </th>
                                        <th>
                                            <div class="table-inner">Properties</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 9600</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· A product with excellent resistance to Fluorine and Oxygen plasma environments</p>
                                                    <p class="dot-txt-rounded">· Compression set characteristics have been improved on the strengths of Kalrez® 9500 and are specialized for CVD/ALD processes.</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 9500</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· Product with excellent heat resistance to high temperatures</p>
                                                    <p class="dot-txt-rounded">· Sticking and outgassing areas improved</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 9300</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· Product with balanced resistance to physical and chemical plasma</p>
                                                    <p class="dot-txt-rounded">· Minimize generation of metal particles</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 9100</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· Product that minimizes particle generation and erosion caused by plasma</p>
                                                    <p class="dot-txt-rounded">· Excellent resistance to dry processes</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 6005</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· Products specialized for etching, ashing, stripping processes, etc.</p>
                                                    <p class="dot-txt-rounded">· Has low sticking characteristics at high temperatures</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 8002</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· Product that minimizes particle generation due to oxygen and fluorine-based plasma</p>
                                                    <p class="dot-txt-rounded">· Has low permanent compression set</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 8085</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· A product that minimizes particle generation in an NF3 plasma environment</p>
                                                    <p class="dot-txt-rounded">· Designed to have high mechanical strength</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-col>
                        <v-col cols="12" md="4">
                            <table class="client-table client-table-lg w-100 border-md-end">
                                <colgroup>
                                    <col style="width: 25%" />
                                    <col style="width: 75%" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Thermal Process</div>
                                        </th>
                                        <th>
                                            <div class="table-inner">Properties</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 8900</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· Product with excellent heat resistance to high temperatures</p>
                                                    <p class="dot-txt-rounded">· Sticking and outgassing areas improved</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 7075</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· Products that maintain mechanical properties at high temperatures</p>
                                                    <p class="dot-txt-rounded">· Has low permanent compression set rate</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 8475</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· Product that lowers seal temperature rise by reducing infrared absorption</p>
                                                    <p class="dot-txt-rounded">· Specialized in Lamp Anneal, RTP Sealing, etc.</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 8575</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· Product with improved elastic recovery and improved outgassing</p>
                                                    <p class="dot-txt-rounded">· Improved resistance to chlorine-based cleaning gases such as CIF3</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-col>
                        <v-col cols="12" md="4">
                            <table class="client-table client-table--last client-table-lg w-100">
                                <colgroup>
                                    <col style="width: 25%" />
                                    <col style="width: 75%" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Wet Process</div>
                                        </th>
                                        <th>
                                            <div class="table-inner">Properties</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 6375</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded">· Used in all wet chemical processes</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 4079</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded">· Universally used in dry and wet processes</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-col>
                    </v-row>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="Kalrez® material properties">
                    <table class="client-table client-table-lg w-100 word-break-word word-sm-keep-all">
                        <thead>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">Kalrez® Grade</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Kalrez® Remark</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Color</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Image</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Hardness</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Max Service Temp. ℃(℉)</div>
                                </th>
                                <th>
                                    <div class="table-inner">Compression Set at 70hr204℃, %</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">9600</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>When exposed to fluorine and oxygen plasma radicals in high temperature vacuum environments, the sealing exhibits extremely low erosion rates and weight loss due to plasma attack and provides excellent chemical resistance to ammonia, ozone and water vapor.​</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">Olive- Green</p>
                                        <v-avatar color="#89AC23" size="24" class="mt-6 mt-md-8" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-9600.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>70</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>315 (599)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>15</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">9500</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>SACVD, FCVD, PECVD processes Suitable for deposition processes that generate ozone, ammonia, and water vapor</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">Tan</p>
                                        <v-avatar color="#FABA86" size="24" class="mt-6 mt-md-8" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-9500.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>76</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>310 (590)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>20</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">9300</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>Used for dielectric etch and has excellent resistance to oxygen- and fluorine-based plasma and chemicals.</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">Brown</p>
                                        <v-avatar color="#800000" size="24" class="mt-6 mt-md-8" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-9300.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>77</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>300 (572)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>25</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">9100</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>Suitable for ALD, HDPCVD, Conductor EtchLow elution and ultra-low particle generation in plasma environments</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">Amber</p>
                                        <v-avatar color="#FFCC00" size="24" class="mt-6 mt-md-8" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-9100.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>77</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>300 (572)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>18</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">8002</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>It is a transparent product for use in the Ash/Strip process and has excellent crack resistance and produces ultra-low fine particles in oxygen- and fluorine-based plasma compared to products containing inorganic additives.​</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">Clear</p>
                                        <v-avatar color="#D9D9D9" size="24" class="mt-6 mt-md-8" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-8002.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>69</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>275 (527)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>12</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">8705</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>Demonstrates chemical resistance to high concentrations of harmful oxygen free radicals caused by high-energy ultraviolet rays emitted from plasma and excellent sealing function even in high-temperature vacuum.​</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">Black</p>
                                        <v-avatar color="#000" size="24" class="mt-6 mt-md-8" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-8705.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>77</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>327 (621)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>24</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">8900</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>It maintains excellent physical properties at high temperatures such as oxidation, ALD, and LPCVD, and has excellent strength, making it suitable for both static and dynamic sealing applications.​</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">Black</p>
                                        <v-avatar color="#000" size="24" class="mt-6 mt-md-8" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-8900.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>76</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>325 (617)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>20</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">8575</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>Exhibits very low IR (infrared) absorption and outgassing characteristics at high temperatures such as oxidation, lamp annealing, and RTP.</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">White</p>
                                        <v-avatar color="#fff" size="24" class="mt-6 mt-md-8 border border-2" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-8575.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>63</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>300 (572)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>25</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">7075 UP</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>Excellent thermal stability (327℃), such as metal and CVD, products made with Kalrez® 7075 UP can be post-processed in ultrapure water</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">Black</p>
                                        <v-avatar color="#000" size="24" class="mt-6 mt-md-8" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-7075-up.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>75</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>327 (621)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>13</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">9500</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>High thermal stability, very low emissions and excellent rigidity, making it suitable for both static and dynamic sealing applications</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">Tan</p>
                                        <v-avatar color="#FABA86" size="24" class="mt-6 mt-md-8" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-9500.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>76</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>310 (590)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>18</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">9600</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>Excellent compression elasticity under high temperature conditions and excellent low outgassing properties in ultra-low vacuum, making it suitable for applications where purity is very important.</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">Olive- Green</p>
                                        <v-avatar color="#89AC23" size="24" class="mt-6 mt-md-8" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-9600-2.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>70</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>315 (599)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>12</p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="Kalrez® Recommended materials for each process" class="mb-40 mb-lg-60">
                    <h5 class="font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium">Plasma Process</h5>
                    <table class="client-table client-table-lg w-100 word-break-word word-sm-keep-all mb-40 mb-lg-60">
                        <thead>
                            <tr>
                                <th class="border-end w-md-17">
                                    <div class="table-inner">Process Type</div>
                                </th>
                                <th class="border-end w-md-26">
                                    <div class="table-inner">Process Remark</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Maximum Service Temperature</div>
                                </th>
                                <th class="border-end w-md-28">
                                    <div class="table-inner">Typical Chemistries</div>
                                </th>
                                <th>
                                    <div class="table-inner">Suggested Product</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>HDPCVD</p>
                                        <span class="font-size-10 font-size-md-12 line-height-13 font-weight-regular grey--text mt-6 mt-md-8">High-Density Plasma <br class="d-none d-md-block" />Chemical Vapor Deposition</span>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>High-density plasma chemical vapor deposition</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>250℃ ~ <span class="font-weight-bold">300℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>Applying TMS to the wafer surface for dissolving and removing organic residues</p>
                                        <span class="font-size-10 font-size-md-12 line-height-13 font-weight-regular grey--text mt-6 mt-md-8">DEMS, TEOS, SiH₄, SiF₄, <br class="d-none d-md-block" />NH₃, O₂, N₂O, C₄F₈, NF₃</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 9100 / 9500</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>PECVD / PEALD</p>
                                        <span class="font-size-10 font-size-md-12 line-height-13 font-weight-regular grey--text mt-6 mt-md-8">Plasma-Enhanced <br class="d-none d-md-block" />Atomic Layer Deposition</span>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>Plasma-enhanced atomic layer deposition</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>275℃ ~ <span class="font-weight-bold">310℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>Use of TMS, DEMS, TEOS</p>
                                        <span class="font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8">SiH₄, SiF₄, NH₃, O₂, N₂O, C₄F₈, NF₃</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 9600</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">
                                            PECVD<br />
                                            Curing Process
                                        </p>
                                        <span class="font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8">Plasma-Enhanced <br class="d-none d-md-block" />Chemical Vapor Deposition</span>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>Coating and curing process using plasma-enhanced chemical vapor deposition technology</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>150℃ ~ <span class="font-weight-bold">200℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>O₃  + UV Light</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 8705 / 9500</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">SACVD / FCVD</p>
                                        <span class="font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8">Sub-Atmospheric Chemical Vapor Deposition</span>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>Layer deposition technology using chemical vapor deposition technology in a partial vacuum environment</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>280℃ ~ <span class="font-weight-bold">300℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">TEP</p>
                                        <span class="font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8">NH₃, O₃, NF₃</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 9500 / 9600</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">Conductor Etch</p>
                                        <span class="font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8">Poly / Metal</span>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>Technology for removing the conductive layer</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>150℃ ~ <span class="font-weight-bold">225℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>CF₄, CHF₃, HBr, BCl₃, CCl₄, Cl₂, NF₃</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 9100 / 9300</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">Dielectric Etch</p>
                                        <span class="font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8">Oxide</span>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>Technology to remove insulating layers such as oxides</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>100℃ ~ <span class="font-weight-bold">180℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>CF₄, C₃F₈, CHF₃, SF₆, O₂, H₂</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 9300</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">Ash / Strip</p>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>Process to remove organic matter from the surface of the ash layer / Strip process is a process to remove oxides</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>180℃ ~ <span class="font-weight-bold">250℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>CF₄, CHF₃, O₂, NH₃, Water Vapor, H₂, Forming Gas</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 9300 / 8002</p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <h5 class="font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium">Thermal Process</h5>
                    <table class="client-table client-table-lg w-100 word-break-word word-sm-keep-all mb-40 mb-lg-60">
                        <thead>
                            <tr>
                                <th class="border-end w-md-17">
                                    <div class="table-inner">Process Type</div>
                                </th>
                                <th class="border-end w-md-26">
                                    <div class="table-inner">Process Remark</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Maximum Service Temperature</div>
                                </th>
                                <th class="border-end w-md-28">
                                    <div class="table-inner">Typical Chemistries</div>
                                </th>
                                <th>
                                    <div class="table-inner">Suggested Product</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">
                                            ALD, LPCVD, <br class="d-none d-md-block" />
                                            Metal CVD
                                        </p>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left flex-wrap line-height-135">
                                        <div>
                                            <div>ALD</div>
                                            <p class="font-size-10 font-size-md-12 font-weight-regular grey--text">Atomic Layer Deposition</p>
                                        </div>
                                        <div class="mt-6 mt-md-8">
                                            <div>LPCVD</div>
                                            <p class="font-size-10 font-size-md-12 font-weight-regular grey--text">Low Pressure Chemical Vapor Deposition</p>
                                        </div>
                                        <div class="mt-6 mt-md-8">
                                            <div>Metal CVD</div>
                                            <p class="font-size-10 font-size-md-12 font-weight-regular grey--text">Metal Chemical Vapor Deposition</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>250℃ ~ <span class="font-weight-bold">300℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>
                                            WF₆, TiCl₄, HF, SiF₄, F₂, <br class="d-none d-md-block" />
                                            N₂O Vapor, Cl₂, ClF₃
                                        </p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 7075 UP / 8900</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">
                                            Oxidation, <br class="d-none d-md-block" />
                                            Nitridation, <br class="d-none d-md-block" />
                                            Diffusion
                                        </p>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left flex-wrap line-height-135">
                                        <div>
                                            <div>Oxidation</div>
                                            <p class="font-size-10 font-size-md-12 font-weight-regular grey--text">The loss of electrons during a reaction by a molecule, atom or ion</p>
                                        </div>
                                        <div class="mt-6 mt-md-8">
                                            <div>Niridation</div>
                                            <p class="font-size-10 font-size-md-12 font-weight-regular grey--text">Heat treating process that diffuses nitrogen into the surface of a metal to create a case-hardened surface</p>
                                        </div>
                                        <div class="mt-6 mt-md-8">
                                            <div>Diffusion</div>
                                            <p class="font-size-10 font-size-md-12 font-weight-regular grey--text">The process of moving impurities from the surface to the inside of a semiconductor device</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>250℃ ~ <span class="font-weight-bold">300℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>
                                            O₂, N₂, N₂O Vapor, <br class="d-none d-md-block" />
                                            Cl₂, O₃, HCl
                                        </p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 7075 UP / 8900</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">
                                            Lamp Anneal, <br class="d-none d-md-block" />
                                            RTP
                                        </p>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left flex-wrap line-height-135">
                                        <p>The crystallinity of the material structure increases due to high temperature heating by exposure to light and is maintained above 1000℃, improving the characteristics of semiconductor devices.</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>250℃ ~ <span class="font-weight-bold">275℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>
                                            Infrared Light, <br class="d-none d-md-block" />
                                            N₂O Vapor, O₂
                                        </p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 8575</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">
                                            Wafer Surface <br class="d-none d-md-block" />
                                            Preparation
                                        </p>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left flex-wrap line-height-135">
                                        <p>Makes the semiconductor wafer surface clean and smoothProcess to enable application to the next process</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>250℃ ~ <span class="font-weight-bold">275℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>NH₃, H₂, F₂, NF₃, HF</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 9500 / 9600</p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <h5 class="font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium">Wet Process</h5>
                    <table class="client-table client-table-lg w-100 word-break-word word-sm-keep-all">
                        <thead>
                            <tr>
                                <th class="border-end w-md-17">
                                    <div class="table-inner">Process Type</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Maximum Service Temperature</div>
                                </th>
                                <th class="border-end w-md-28">
                                    <div class="table-inner">Typical Chemistries</div>
                                </th>
                                <th>
                                    <div class="table-inner">Suggested Product</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">Wafer Preparation</p>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>70℃ ~ <span class="font-weight-bold">125℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner left flex-wrap line-height-135">
                                        <div class="w-100">
                                            <div>UPW</div>
                                            <p class="font-size-10 font-size-md-12 grey--text">(Ultra-Pure Water)</p>
                                        </div>
                                        <div class="w-100 mt-6 mt-md-8">
                                            <div>Piranha</div>
                                        </div>
                                        <div class="w-100 mt-6 mt-md-8">
                                            <div>SC-1, SC-2, O₃</div>
                                        </div>
                                        <div class="w-100 mt-6 mt-md-8">
                                            <div>EKC fluids</div>
                                            <p class="font-size-10 font-size-md-12 grey--text">(Electronic Grade Chemicals)</p>
                                        </div>
                                    </div>
                                </td>
                                <td rowspan="4">
                                    <div class="table-inner left flex-wrap line-height-135">
                                        <div class="w-100 font-weight-bold">Kalrez® W240UP</div>
                                        <p class="w-100 mt-6 mt-md-8">This O-ring is used in filters, valves, pumps, etc. that require chemical resistance and is black in color.</p>
                                        <p class="w-100 mt-6 mt-md-8">Resistant to acids and alkalis, preferred as a product for high wetness processes.</p>
                                        <p class="w-100 mt-6 mt-md-8">After manufacturing, there are almost no particles in the product through an ultrapure water cleaning process.</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">Etching</p>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>70℃ ~ <span class="font-weight-bold">95℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner left flex-wrap line-height-135">
                                        <p>HNO₃, HF₂, H₂O, H₃PO₄, NH₄OH</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">Stripping</p>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>70℃ ~ <span class="font-weight-bold">125℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner left flex-wrap line-height-135">
                                        <div class="w-100">
                                            <div>NMP</div>
                                            <p class="font-size-10 font-size-md-12 grey--text">(N-Methyl-2-Pyrrolidone)</p>
                                        </div>
                                        <div class="w-100 mt-6 mt-md-8">
                                            <div>Alkanolamine</div>
                                        </div>
                                        <div class="w-100 mt-6 mt-md-8">
                                            <div>Hydroxylamine</div>
                                        </div>
                                        <div class="w-100 mt-6 mt-md-8">
                                            <div>Acetone / IPA</div>
                                        </div>
                                        <div class="w-100 mt-6 mt-md-8">
                                            <div>EKC 265</div>
                                            <p class="font-size-10 font-size-md-12 grey--text">(Electronic Grade Chemicals)</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">Copper Plating</p>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>70℃ ~ <span class="font-weight-bold">125℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner left flex-wrap line-height-135">
                                        <div class="w-100">
                                            <div>CuSO₄ Solution, H₂SO₄</div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="Kalrez® Groove">
                    <p class="page-text color-grey-51 mb-30 mb-lg-52">If problems arise when developing new equipment or changing from Viton O-rings to Kalrez® O-rings, the O-ring groove is one of the items to be reviewed. Kalrez® has higher thermal expansion characteristics than Viton, so if used at high temperatures without considering this and changing the groove, cracks or extrusion may occur.</p>
                    <h5 class="font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium">Rectangular Groove for Static Application</h5>
                    <table class="client-table client-table-lg w-100 word-break-word word-sm-keep-all mb-40 mb-lg-60">
                        <thead>
                            <tr>
                                <th class="border-end w-md-80px">
                                    <div class="table-inner">Code Name</div>
                                </th>
                                <th class="border-end w-md-220px">
                                    <div class="table-inner">Product Drawing</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Code No.</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">CSD</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Temp.(℃)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Width(G)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Depth(H)</div>
                                </th>
                                <th>
                                    <div class="table-inner">Radius(R)</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th rowspan="6" class="border-end">
                                    <div class="table-inner">AS568A</div>
                                </th>
                                <td rowspan="6" class="border-end">
                                    <div class="table-inner">
                                        <v-img max-width="198" src="/images/sub/distributor/kalrez/groove-rectangular.png" class="w-100px w-md-198px" />
                                    </div>
                                </td>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">102 ~ 178</div>
                                </td>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">2.62± <span class="font-size-10 font-size-md-12">0.08</span></div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">≤ 180</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">3.20</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">2.00</div>
                                </td>
                                <td>
                                    <div class="table-inner">0.40</div>
                                </td>
                            </tr>
                            <tr>
                                <td class="border-end">
                                    <div class="table-inner">≤ 250</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">3.55</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">2.00</div>
                                </td>
                                <td>
                                    <div class="table-inner">0.40</div>
                                </td>
                            </tr>
                            <tr>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">201 ~ 284</div>
                                </td>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">3.53±<span class="font-size-10 font-size-md-12">0.10</span></div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">≤ 180</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.40</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">2.85</div>
                                </td>
                                <td>
                                    <div class="table-inner">0.60</div>
                                </td>
                            </tr>
                            <tr>
                                <td class="border-end">
                                    <div class="table-inner">≤ 250</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.80</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">2.85</div>
                                </td>
                                <td>
                                    <div class="table-inner">0.60</div>
                                </td>
                            </tr>
                            <tr>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">309 ~ 395</div>
                                </td>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">5.33±<span class="font-size-10 font-size-md-12">0.13</span></div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">≤ 180</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">6.50</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.30</div>
                                </td>
                                <td>
                                    <div class="table-inner">0.90</div>
                                </td>
                            </tr>
                            <tr>
                                <td class="border-end">
                                    <div class="table-inner">≤ 250</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">7.15</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.30</div>
                                </td>
                                <td>
                                    <div class="table-inner">0.90</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <h5 class="font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium">Dovetail Groove for Application</h5>
                    <table class="client-table client-table-lg w-100 word-break-word word-sm-keep-all">
                        <thead>
                            <tr>
                                <th class="border-end w-md-80px">
                                    <div class="table-inner">Code Name</div>
                                </th>
                                <th class="border-end w-md-220px">
                                    <div class="table-inner">Product Drawing</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Code No.</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">CSD</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Temp.(℃)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Top Width to Sharps (G`)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Top Width (G)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Depth (H)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Top Radius (R1)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Bottom Radius (R1)</div>
                                </th>
                                <th>
                                    <div class="table-inner">Side Wall Angle</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th rowspan="6" class="border-end">
                                    <div class="table-inner">AS568A</div>
                                </th>
                                <td rowspan="6" class="border-end">
                                    <div class="table-inner">
                                        <v-img max-width="198" src="/images/sub/distributor/kalrez/groove-dovetail.png" class="w-100px w-md-198px" />
                                    </div>
                                </td>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">201~284</div>
                                </td>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">3.53±<span class="font-size-10 font-size-md-12">0.10</span></div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">≤ 180</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">2.98</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">3.20</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">2.85</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.20</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.80</div>
                                </td>
                                <td rowspan="4">
                                    <div class="table-inner">0.80</div>
                                </td>
                            </tr>
                            <tr>
                                <td class="border-end">
                                    <div class="table-inner">≤ 250</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">3.53</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">3.75</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">2.85</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.20</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.80</div>
                                </td>
                            </tr>
                            <tr>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">201~284</div>
                                </td>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">5.33±<span class="font-size-10 font-size-md-12">0.13</span></div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">≤ 180</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.47</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.90</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.30</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.40</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.80</div>
                                </td>
                            </tr>
                            <tr>
                                <td class="border-end">
                                    <div class="table-inner">≤ 250</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.77</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">5.20</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.30</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.40</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.80</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p class="font-size-12 font-size-md-14 mt-8 mt-lg-10 mb-40 mb-lg-60">*Although it is a dynamic part with a dovetail design, when applied to process conditions above 250℃, the lifespan may be shorter than that of a static product.</p>

                    <h5 class="font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium">Half-Dovetail Groove for Static Application</h5>
                    <table class="client-table client-table-lg w-100 word-break-word word-sm-keep-all">
                        <thead>
                            <tr>
                                <th class="border-end w-md-80px">
                                    <div class="table-inner">Code Name</div>
                                </th>
                                <th class="border-end w-md-220px">
                                    <div class="table-inner">Product Drawing</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Code No.</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">CSD</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Temp.(℃)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Top Width to Sharps (G`)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Top Width (G)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Depth (H)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Top Radius (R1)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Bottom Radius (R1)</div>
                                </th>
                                <th>
                                    <div class="table-inner">Side Wall Angle</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th rowspan="6" class="border-end">
                                    <div class="table-inner">AS568A</div>
                                </th>
                                <td rowspan="6" class="border-end">
                                    <div class="table-inner">
                                        <v-img max-width="198" src="/images/sub/distributor/kalrez/groove-half-dovetail.png" class="w-100px w-md-198px" />
                                    </div>
                                </td>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">201~284</div>
                                </td>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">3.53±<span class="font-size-10 font-size-md-12">0.10</span></div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">≤ 180</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">3.79</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">3.90</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">2.85</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.20</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.80</div>
                                </td>
                                <td rowspan="4">
                                    <div class="table-inner">24°</div>
                                </td>
                            </tr>
                            <tr>
                                <td class="border-end">
                                    <div class="table-inner">≤ 250</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.19</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.30</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">2.85</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.20</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.80</div>
                                </td>
                            </tr>
                            <tr>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">201~284</div>
                                </td>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">5.33±<span class="font-size-10 font-size-md-12">0.13</span></div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">≤ 180</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">5.49</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">5.60</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.30</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.20</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.80</div>
                                </td>
                            </tr>
                            <tr>
                                <td class="border-end">
                                    <div class="table-inner">≤ 250</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">6.09</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">6.20</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.30</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.20</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.80</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="Kalrez® Standard">
                    <p class="page-text color-grey-51 mb-14 mb-lg-16">Kalrez® parts has O-Rings in stock that comply with AS-568, Metric, JIS, and NW standards, and has the stocks necessary for various industries such as semiconductor and display processes, enabling rapid response to customer requests.</p>
                    <div class="page-text font-weight-medium mb-40 mb-lg-60">You can download the Kalrez® List of standard specifications and check the list by standard.</div>
                    <v-btn color="primary" href="/assets/document/IST_Dupont Kalrez List-Up.pdf" download>Download Standard Specifications Kalrez® List</v-btn>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <inquiry src="/images/sub/distributor/dupont/dupont-img1.png" name="M. S. Hwang" tel="+82-31-765-2268" mail="mshwang@ist-co.kr" fax="+82-31-765-2389" link="https://www.dupont.com/kalrez.html" linkBg="/images/sub/distributor/dupont/dupont-img2.png"> </inquiry>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
import SubLineLayout from "@/components/client/en/sub/sub-line-layout.vue";
import SubBgImage from "@/components/client/en/sub/sub-bg-image.vue";
import IconLineBox from "@/components/client/en/sub/sub-icon-line-box.vue";
import Inquiry from "@/components/client/en/sub/sub-inquiry.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubLineLayout,
        SubBgImage,
        IconLineBox,
        Inquiry,
    },
};
</script>

<style lang="scss" scoped>
.client-table-lg td .table-inner {
    min-height: initial;
}
@media (min-width: 768px) {
    .w-md-198px {
        width: 198px !important;
    }
}
</style>